__turbopack_context__.v({
  "blurredBtn": "-b5Xja_blurredBtn",
  "buttonContainer": "-b5Xja_buttonContainer",
  "container": "-b5Xja_container",
  "content": "-b5Xja_content",
  "subTitle": "-b5Xja_subTitle",
  "title": "-b5Xja_title",
});
